<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { ToggleGroupItem, type ToggleGroupItemProps } from "reka-ui";
import { cn } from "@/shared/lib/utils";

const props = defineProps<
  ToggleGroupItemProps & {
    class?: HTMLAttributes["class"];
  }
>();
</script>

<template>
  <ToggleGroupItem
    v-bind="props"
    :class="
      cn(
        'inline-flex items-center justify-center rounded-md px-3 py-1.5 text-sm font-medium transition-colors',
        'border border-zinc-200 bg-white hover:bg-zinc-100 hover:text-zinc-900',
        'focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-zinc-950',
        'disabled:pointer-events-none disabled:opacity-50',
        'data-[state=on]:border-zinc-200 data-[state=on]:bg-zinc-100 data-[state=on]:text-zinc-900',
        'dark:border-zinc-800 dark:bg-zinc-950 dark:hover:bg-zinc-800 dark:hover:text-zinc-50 dark:data-[state=on]:bg-zinc-800 dark:data-[state=on]:text-zinc-50',
        props.class,
      )
    "
  >
    <slot />
  </ToggleGroupItem>
</template>
